module.exports = __webpack_public_path__ + "media/images/sp/components/specials/special_offer/special_sticker-b9b540d0244686c87be53d0c15ae7a5f.png";